function Unauthorized() {
  return (
    <main id="skip-to-content" className="text-center mt-5">
      <h1>Oops!</h1>
      <p>Looks like you do not have access to this page</p>
    </main>
  );
}

export default Unauthorized;
